export default __webpack_public_path__ + "static/media/allOn_ua_d.ed5bc497.svg";